//https://github.com/zxfjd3g/171208_gshop
import axios from "axios";
import store from "@/store";
import QS from "qs";
import { Message } from "element-ui";
import router from "@/router";
axios.defaults.timeout = 10000;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断vuex中是否存在token
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    const token = store.state.token;
    token && (config.headers.Authorization = token);
    return config;
  },
  error => {
    return Promise.error(error);
  }
);
// 响应拦截器
axios.interceptors.response.use(
  response => {
    //console.log(response.data);
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误response.status
    if (response.data.code == 300) {
      Message.error("请先登录");
      router.replace({
        path: "/login",
        query: {
          redirect: router.currentRoute.fullPath
        }
      });
      return false;
    } else if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    if (error.response.status) {
      // console.log(1); // 404请求不存在
      switch (error.response.status) {
        // 401: 未登录
        // case 401:
        // 	router.replace({
        // 		path: '/about',
        // 		query: {
        // 			redirect: router.currentRoute.fullPath
        // 		}
        // 	});
        // 	break;
        case 404:
          console.log(0);
          Message.error("网络请求不存在");
          break;
        // 其他错误，直接抛出错误提示
        default:
          Message.error(error.response.data.message);
      }
      return Promise.reject(error.response);
    }
  }
);

export default function ajax(url, data = {}, type = "GET") {
  return new Promise(function(resolve, reject) {
    // 执行异步ajax请求
    let promise;
    if (type === "GET") {
      // 准备url query参数数据
      let dataStr = ""; //数据拼接字符串
      Object.keys(data).forEach(key => {
        dataStr += key + "=" + data[key] + "&";
      });
      if (dataStr !== "") {
        dataStr = dataStr.substring(0, dataStr.lastIndexOf("&"));
        url = url + "?" + dataStr;
      }
      // 发送get请求
      promise = axios.get(url);
    } else {
      // 发送post请求
      promise = axios.post(url, QS.stringify(data));
    }
    promise
      .then(function(response) {
        // 成功了调用resolve()
        resolve(response.data);
      })
      .catch(function(error) {
        //失败了调用reject()
        reject(error);
      });
  });
}
